export { default } from './PersonalDetails'
